export function getSessionDuration() {
  const initTimestamp = getCookie('sophia_st');
  if (!initTimestamp) return null;

  return (currentTimestamp() - initTimestamp) || null;
}

export function initSessionDuration() {
  const val = getCookie('sophia_st')

  if (!val || /[^\d]/.test(val)) {
    const date = Math.round(new Date().getTime() / 1000)

    setCookie('sophia_st', date);
  }
}

function getUpperLevelDomain() {
  const domainParts = document.location.hostname.split('.');
  return (domainParts.length > 2) ? domainParts.slice(1).join('.') : domainParts.join('.');
}

function setCookie(name, value, options = {}) {
  options = {
    domain: getUpperLevelDomain(),
    path: '/',
    samesite: 'lax',
    ...options
  };

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function currentTimestamp() {
  return Math.round(new Date().getTime() / 1000);
}
